/* ─────────────────────────────────────────────
   ATENA CONSULTING — index.js
   Entry point principale

   GSAP + ScrollTrigger registrati UNA SOLA VOLTA
   qui, prima di tutto il resto.
   Tutti gli altri moduli importano solo { gsap }
   senza chiamare registerPlugin.
───────────────────────────────────────────── */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ── Registrazione unica ──────────────────────
// NON ripetere gsap.registerPlugin(ScrollTrigger)
// in nessun altro modulo
gsap.registerPlugin(ScrollTrigger);

/* Bootstrap */
// import "bootstrap";

import {
  // Alert,       // Dismissible alerts
  Button,      // Toggle button states
  // Carousel,    // Slideshow component
  Collapse,    // Accordion-like collapsing elements
  // Dropdown,    // Dropdown menus
  // Modal,       // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  Tooltip, // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

/* Moduli — inizializzazione sincrona (listeners, setup DOM) */
import animations from "./js/animations";
import navbar     from "./js/navbar";
import footer     from "./js/footer";
import sidebar    from "./js/sidebar";
import search     from "./js/search";
import header     from "./js/header";
import scrollTop  from "./js/scrollTop";
import massimo    from "./js/massimo";

// Moduli che usano ScrollTrigger
import blocks          from "./js/blocks";
import sidebarContatti from "./js/sidebar-contatti";
import bloccoNumeri    from "./js/blocco-numeri";
import newsletter      from "./js/newsletter";
import bloccoCarousel  from "./js/blocco-carousel-loghi";

/* ── Init sincrono (no ScrollTrigger) ─────────
   Questi possono girare subito                 */
navbar();
footer();
sidebar();
search();
header();
scrollTop();
massimo();

/* ── Init asincrono (ScrollTrigger) ───────────
   Un solo window.load — layout stabile,
   ScrollTrigger calcola posizioni corrette     */
function initAll() {
  // Ordine importante: animations prima degli altri
  // così i data-animate sono già processati
  animations();
  sidebarContatti();
  bloccoNumeri();
  newsletter();
  bloccoCarousel();
  blocks();

  // Unico refresh globale alla fine
  ScrollTrigger.refresh();
}

if (document.readyState === 'complete') {
  initAll();
} else {
  window.addEventListener('load', initAll);
}